module.exports = __webpack_public_path__ + "img/shop@2x.4fbb55e6.png";